@if (chartData && xLabels && lineChartData) {
  <div class="chart-canvas-container">
    <canvas
      baseChart
      #myChart="base-chart"
      [data]="lineChartData"
      [options]="lineChartOptions"
      [type]="'line'"
      [legend]="false"
      >
    </canvas>
  </div>
} @else {
  {{ 'global.error.loadData' | translate }}
}
